import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';

export class DriverEta {
  @autoserialize
  reservationId: number;

  @autoserializeAs(Date)
  estimatedTimeOfArrival: Date;

  @autoserialize
  timeZone: string;

  @autoserializeAs(Date)
  estimatedAt: Date;

  static OnSerialized(driverEta: DriverEta, json: any): void {
    if (!isNullOrUndefined(driverEta.estimatedTimeOfArrival)) {
      json.estimatedTimeOfArrival = DateUtil.serializeDate(driverEta.estimatedTimeOfArrival);
    }
    if (!isNullOrUndefined(driverEta.estimatedAt)) {
      json.estimatedAt = DateUtil.serializeDate(driverEta.estimatedAt);
    }
  }

  static OnDeserialized(instance: DriverEta, json: any): void {
    if (!isNullOrUndefined(json['estimatedTimeOfArrival'])) {
      instance.estimatedTimeOfArrival = DateUtil.deserializeDate(json['estimatedTimeOfArrival']);
    }
    if (!isNullOrUndefined(json['estimatedAt'])) {
      instance.estimatedAt = DateUtil.deserializeDate(json['estimatedAt']);
    }
  }
}
